module.exports = __webpack_public_path__ + "static/media/gift-box-motion.593ad4b6.lottie";